import React, {Component} from 'react';

import InputMask from 'react-input-mask';

import Datepicker from "../../../../components/Datepicker/datepicker";
import PlateInput from "../../../../components/PlateInput/plateInput";

export default class ProgrammingForm extends Component {

    componentDidMount(){
        window.initializeCollapsible();
        window.initializeSelects('body');
        window.bindSelectAction(this.productSelect, this.props.handleSelect);
        window.bindSelectAction(this.terminalSelect, this.props.handleSelect);
        window.bindSelectAction(this.providerSelect, this.props.handleSelect);
    }

    render() {
        // let date = new Date();
        // let date2 = new Date();
        // let maxDate = new Date(date.setTime(date.getTime() + (24*60*60*1000*30)));
        // let minDate = new Date(date2.setTime(date2.getTime() - (24*60*60*1000*30)));

        return (
            <div className={"row no-padding thin-row trip-form"}>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Información Orden</h4>
                    </div>
                    <div className={"row margin-top-10"}>
                        <div className={"col s6 input-field"}>
                            <label className="active">Proveedor</label>
                            <select defaultValue={this.props.state.provider}
                                    data-state-var="provider" ref={ref => {this.providerSelect = ref}}>
                                <option value="">Seleccione proveedor</option>
                                {this.props.state.providers && this.props.state.providers.map(provider => {
                                    return <option key={provider.id} id={provider.id}
                                                   value={provider.id}>{provider.business_name}</option>
                                })}
                            </select>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Producto</label>
                            <select defaultValue={this.props.state.product}
                                    data-state-var="product"  ref={ref => {this.productSelect = ref}}>
                                <option value="">Seleccione producto</option>
                                {this.props.state.products && this.props.state.products.map(product => {
                                    return <option key={product.id} id={product.id}
                                                   value={product.id}>{product.name}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Tipo de viaje</label>
                            <p className={"field-p"}>Viaje FOB</p>
                        </div>
                        <div className={"col s6 input-field"}>
                            <label className="active">Destino</label>
                            <select defaultValue={this.props.state.terminal}
                                    data-state-var="terminal"  ref={ref => {this.terminalSelect = ref}}>
                                <option value="">Seleccione destino</option>
                                {this.props.state.terminals && this.props.state.terminals.map(terminal => {
                                    return <option key={terminal.id} id={terminal.id}
                                                   value={terminal.id}>{terminal.name}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Orden ST</label>
                            <input placeholder="Ingrese número ST" value={this.props.state.st_number}
                                   onChange={(ev) => this.props.handleInput('st_number', ev.target.value)}
                            />
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Cia ST</label>
                            <input placeholder={"Ingrese número ST"} value={this.props.state.st_company}
                                   onChange={(ev) => this.props.handleInput('st_company', ev.target.value)}/>
                        </div>
                    </div>
                    <div className={"row no-margin"}>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Número de Línea</label>
                            <input placeholder={"Ingrese numero de linea"} value={this.props.state.line_number}
                                   onChange={(ev) => this.props.handleInput('line_number', ev.target.value)}/>
                        </div>
                        <div className={"col s6 input-field input-grey"}>
                            <label className="active">Cantidad de Litros a 15º</label>
                            <input placeholder={"Ingrese cantidad"} value={this.props.state.order_volume}
                                   onChange={(ev) => this.props.handleInput('order_volume', ev.target.value)}/>
                        </div>
                    </div>
                </div>
                <div className={"col s6 no-padding"}>
                    <div style={{height: 37, backgroundColor: '#d9d9d9', padding: 10}}>
                        <h4 className={'table-subtitle'}>Información Transporte</h4>
                    </div>
                    <div style={{borderLeft: '1px solid #404040', paddingLeft: 20}}>
                        <div className={"row margin-top-10"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Empresa Transportista</label>
                                <input placeholder={"Ingrese empresa"} value={this.props.state.carrier}
                                       onChange={(ev) => this.props.handleInput('carrier', ev.target.value)}
                                />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">C.U.I.T</label>
                                <InputMask placeholder={"Ingrese CUIT"} value={this.props.state.carrier_doc}
                                           mask={'99-99999999-9'}
                                           onChange={(ev) => this.props.handleInput('carrier_doc', ev.target.value)}
                                />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Chofer - Nombre y Apellido</label>
                                <input placeholder={"Ingrese nombre del chofer"} value={this.props.state.driver_name}
                                       onChange={(ev) => this.props.handleInput('driver_name', ev.target.value)}
                                />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Licencia de Conducir</label>
                                <input placeholder={"Ingrese licencia"} value={this.props.state.driver_doc}
                                       onChange={(ev) => this.props.handleInput('driver_doc', ev.target.value)}/>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col s6 input-field "}>
                                <label className="active">Fecha estimada de Carga</label>
                                {/* TODO - Review this in a few days from now 14/09/2018 max={maxDate} min={minDate}}*/}
                                <Datepicker classname="input-grey" placeholder={"Ingrese fecha"}
                                            value={this.props.state.estimated_load_date} format={"YYYY-MM-DD"}
                                            id="estimated_load_date" action={this.props.handleDate} />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Transporte Unidad</label>
                                <input placeholder={"Ingrese unidad"} value={this.props.state.truck_id}
                                       onChange={(ev) => this.props.handleInput('truck_id', ev.target.value)}/>
                            </div>
                        </div>
                        <div className={"row no-margin"}>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Patente Chasis</label>
                                <PlateInput
                                    placeholder="Ingrese patente del chasis" value={this.props.state.truck_plate}
                                    action={this.props.handleInput} name={'truck_plate'}
                                />
                            </div>
                            <div className={"col s6 input-field input-grey"}>
                                <label className="active">Patente Acoplado</label>
                                <PlateInput
                                    placeholder="Ingrese patente del acoplado" value={this.props.state.trailer_plate}
                                    action={this.props.handleInput} name={'trailer_plate'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/newTrip/ProgrammingForm.js